export default __webpack_public_path__ + "2b8b90da6f5e460f7f7e2dc693ff7d90.png";